var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"share"},_vm._l((_vm.lists),function(n,i){return _c('share-item',{key:i,attrs:{"share":n}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }